import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import N from 'utils/navigation'
import { PERMISSION_ONLY_ORDER_READ } from 'utils/Subscription/PermissionComposites'
import { useHasPermission } from 'utils/Subscription/RequiredPermissions'

export const AddMechanicStepCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()
  const [isPortal] = useHasPermission(PERMISSION_ONLY_ORDER_READ)

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <PersonAddIcon />,
        content: isPortal ? t('SetupWizard.MechanicSummary', { context: 'portal' }) : t('SetupWizard.MechanicSummary'),
        buttonText: t('SetupWizard.MechanicCTA'),
        actionOnClick: () => {
          N.push('/settings/employees/new?Functions=Mechanic')
        }
      }}
    />
  )
}
